import {useSelector} from 'react-redux'
import {getIsCheckInAtLeastSixDaysAway} from 'modules/search/selectors'

import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'

export const useFreezableFilter = (): boolean => {
  const isCheckInAtLeastSixDaysAway = useSelector(
    getIsCheckInAtLeastSixDaysAway
  )
  const {
    retention: {hasDealFreezeFilter}
  } = useBrandCapabilities()

  return isCheckInAtLeastSixDaysAway && hasDealFreezeFilter
}
